const styleClass = (props: string[] = [], prefix: string) =>
    props.map((item) => `${prefix}-${item}`).join(' ');

export default styleClass;
